import { fetchUrlToBase64 } from "@/app/_actions/getFileUrl";

import { base64ToFile } from "./base64ToFile";

/**
 * Создает File из URL или Base64 строки.
 * Работает как с `image` так и с `video`
 * @param fileUrl URL или Base64 строка файла
 * @param filename Имя создаваемого файла
 * @returns `Promise<File>`
 * @throws `Error` если не удалось создать файл
 */
export const createFile = async (
  fileUrl: string,
  filename = "file",
): Promise<File> => {
  if (!fileUrl || !filename) {
    throw new Error("fileUrl и filename обязательны");
  }

  try {
    let base64Data = fileUrl;

    if (
      !fileUrl.startsWith("data:image/") &&
      !fileUrl.startsWith("data:video/")
    ) {
      base64Data = await fetchUrlToBase64(fileUrl);
    }

    const file = base64ToFile(base64Data, filename);

    if (!file) {
      throw new Error("Не удалось создать файл");
    }

    return file;
  } catch (error) {
    const message =
      error instanceof Error ? error.message : "Неизвестная ошибка";
    throw new Error(`Ошибка при создании файла: ${message}`);
  }
};
